export default __webpack_public_path__ + "static/media/8.fd013b2b.jpg";